<ion-content>
  @if (!isProd) {
    <div class="non-prod-version version">
      <span class="version-wrapper">
        v{{ buildNumber }}
      </span>
    </div>
  }

  <div (click)="checkForUpdate()" class="check-update-hidden"></div>
  <div class="d-flex align-items-center justify-content-center w-100 h-100 p-4">
    @if (!isLoading) {
      <form (keyup.enter)="login()" [formGroup]="loginForm" class="w-100 auth-form">
        <img (click)="checkForUpdate()" alt="" class="w-100 mb-3" src="assets/images/logo-smart-moving.svg">
        <ion-text>
          <h2 class="mt-0 mb-3">Welcome Back!</h2>
        </ion-text>
        <div class="d-flex flex-column">
          <ion-item class="no-inner-padding custom-input--login">
            <ion-label class="label-form" position="stacked">Email Address</ion-label>
            <sm-text-control [control]="loginForm.controls.emailAddress" class="w-100" type="email"></sm-text-control>
          </ion-item>
        </div>
        <div class="d-flex flex-column">
          <ion-item class="no-inner-padding custom-input--login">
            <ion-label class="label-form" position="stacked">Password</ion-label>
            <sm-text-control [control]="loginForm.controls.password" class="w-100" type="password"></sm-text-control>
          </ion-item>
        </div>
        <sm-checkbox class="mt-2 py-2" formControlName="rememberMe" labelText="Remember Me"></sm-checkbox>
        @if (userHasReachedMaxFailedLogins) {
          <div class="recaptcha-container">
            <re-captcha formControlName="reCaptchaToken"></re-captcha>
          </div>
        }
        <ion-button (click)="login()" [disabled]="isSubmitting" expand="full" type="submit">
          @if (!isSubmitting) {
            Sign In
          } @else {
            <ion-spinner name="bubbles"></ion-spinner> &nbsp;
            Signing in...
          }
        </ion-button>
        @if (biometricLoginAvailable && !isSubmitting) {
          <ion-button (click)="loginWithBiometric()" expand="full">
            Sign In with {{ biometricTypeText }}
          </ion-button>
        }
        <ion-button color="light" expand="full" routerLink="/forgot-password"> Forgot your password?</ion-button>
        <div class="sm-font-size-small text-center">
          <ion-button expand="full" fill="clear" href="https://www.smartmoving.com/privacy-mobile-app" size="small" target="_blank">Privacy Policy</ion-button>
        </div>
      </form>
    }
  </div>

  <div (click)="changeEnvironment()" class="version">
    <span class="version-wrapper">
      v{{ version }}
    </span>
  </div>

</ion-content>
